import axios from 'axios';

export default async function getAllLocationGroupInvites({
  accessToken,
  locationGroupId,
  page = 0,
  pageSize = 10,
  query = '',
}) {
  try {
    const requestOptions = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    const { data } = await axios.get(
      `${process.env.REACT_APP_INVITES_API_URL}/location-group/${locationGroupId}?page=${page}&pageSize=${pageSize}&query=${query}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    return null;
  }
}
